/** @format */

import { Divider } from '@mui/material';
import { Box } from '@mui/system';
import { Outlet } from 'react-router-dom';
import DeleteApplication from '../../pages/DeleteApplication';
import { sessions } from '../localstorage/SessionStorage';
import HomeNavBar from '../navigation/homeNavBar';

function HomeLayout() {
  return (
    <Box component='main'>
      <HomeNavBar />
      <Box pb={2}></Box>

      <Box className='home_layout_container'>
        <Outlet />
      </Box>

      <Box
        mb={4}
        mt={1}
        sx={{
          padding: 1,
          textAlign: 'center',
          bottom: 0,
          right: 0,
          left: 0,
        }}>
        <Divider sx={{ mt: 3, mb: 2 }} />

        {sessions.getToken() && <DeleteApplication />}

        <Box mt={2}>
          {`© ${new Date().getFullYear()} - Thuthuka Bursary Application System`}
        </Box>
      </Box>
    </Box>
  );
}

export default HomeLayout;
